import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
	imports: [],
    standalone: true
})

export class LoaderComponent {
	@Input() size: number = 200;
}